// @ts-nocheck
import DynamicDropdown, {
    DynamicDropdownProps as BaseDynamicDropdownProps,
    OptionObject,
} from "@insite/mobius/DynamicDropdown";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import upperFirst from "lodash/upperFirst";
import React, { FC } from "react";
import { useTheme } from "styled-components";

type DynamicDropdownProps = Omit<BaseDynamicDropdownProps, "theme">;
const errorText = "This field is invalid.";
const options: OptionObject[] = [
    {
        optionText: "Option #1",
    },
    {
        optionText: "Option #2",
    },
    {
        optionText: "Disabled Option",
        disabled: true,
    },
    {
        optionText: "Option #3",
    },
];

const Row: FC<DynamicDropdownProps> = ({ label, ...props }) => {
    const moreOption = <Link href="#">See all results</Link>;

    return (
        <>
            <GridItem width={4}>
                <DynamicDropdown label={label} moreOption={moreOption} {...props} />
            </GridItem>
            <GridItem width={4}>
                <DynamicDropdown label={`${label} (Disabled)`} disabled moreOption={moreOption} {...props} />
            </GridItem>
            <GridItem width={4}>
                <DynamicDropdown
                    label={`${label} (Error)`}
                    required
                    error={errorText}
                    moreOption={moreOption}
                    {...props}
                />
            </GridItem>
        </>
    );
};

const Variant: FC<DynamicDropdownProps> = props => {
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);

    return (
        <StyleguideSection variant="h3" title={upperFirst(props.sizeVariant)}>
            <GridContainer {...gridContainerProps}>
                <Row label="Base" {...props} />
                <Row label="Placeholder" {...props} placeholder="Select an option" />
                <Row label="Selection" {...props} selected="Option #2" />
                <Row label="Loading" {...props} isLoading />
            </GridContainer>
        </StyleguideSection>
    );
};

const StyleguideDynamicDropdowns: FC = () => (
    <StyleguideSection title="Dynamic Dropdowns">
        <Variant options={options} sizeVariant="default" />
        <Variant options={options} sizeVariant="small" />
        <Variant options={options} sizeVariant={"xsmall" as any} />
    </StyleguideSection>
);

export default StyleguideDynamicDropdowns;
